{"errno":-2,"code":"ENOENT","syscall":"open","path":"/Users/robbymac/Desktop/Robby/Project/angular/packages/core/services/managers/circle-manager.ts"}